"use strict";
// Combines proposed changes into an object to overlay the careplan section data
var Model = require("../types/Model.js");
var jsonpatch = require("fast-json-patch");
var prop = require("prop");
var getChanges = prop("changes");

module.exports = Model({
	name: "careplanoverlay",
	init: init,
	listeners: listeners,

	_current: null,
	_proposed: null,

	recalculate: recalculate,
});

function init() {
	this._current = {};
	this._proposed = [];
	this.push({});
}

function listeners() {
	return {
		"careplansection:updated": Model.makeRecalculator("careplan"),
		"careplanproposedchanges:updated": Model.makeRecalculator("proposed"),
	};
}

function recalculate() {
	var careplan = this._careplan;
	var proposed = this._proposed;

	if(!careplan || !proposed) return;

	var cloned = JSON.parse(JSON.stringify(careplan));
	var changes = proposed.map(getChanges).reduce(concat, []);

	changes.forEach(function(change){
		try {
			jsonpatch.applyOperation(cloned, change, true);
		} catch(e){
			console.warn("Error patching overlay", e);
		}
	});

	this.push(cloned);
}

function concat(a, b) {
	if(!b) return a;
	return a.concat(b);
}
